export const editMutations = <const>{
	NAKLAD_STREDISKO_SELECT_MAPPER: 'NAKLAD_STREDISKO_SELECT_MAPPER',
	ZAPUJCKA_VOZIDLO_FILTER_SELECT_MAPPER: 'ZAPUJCKA_VOZIDLO_FILTER_SELECT_MAPPER',
	ZAPUJCKA_ZAKAZNIK_FILTER_SELECT_MAPPER: 'ZAPUJCKA_ZAKAZNIK_FILTER_SELECT_MAPPER',
};

export const editActions = <const>{
	VOZIDLO_CHANGE: 'vozidloChange',
};
